import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Profile from './Profile';
import Stream from './Stream';
import { GuestUserWrapper } from './guest.styled';
import { ProfileGraphInfo } from './types';

interface GuestUserProps {
  username: string;
  user: ProfileGraphInfo;
}

const GuestUser = ({ username, user }: GuestUserProps) => (
  <GuestUserWrapper>
    <Profile user={user} />

    <Stream username={username} />
  </GuestUserWrapper>
);

export default function GuestUserPage({ username, user }: GuestUserProps) {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60, // 1 hour
      },
    },
  });
  return (
    <QueryClientProvider client={client}>
      <GuestUser username={username} user={user} />
    </QueryClientProvider>
  );
}
